import { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { getExtraJobData } from './getExtraJobData';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';

export const useGetExtraJobData = (
  jobId: string | undefined,
  timeZone: string,
  minLat: number,
  maxLat: number,
  minLon: number,
  maxLon: number
): UseQueryResult<Record<string, any>[]> => {
  const { dbSession } = useSession();
  return useQuery(
    ['getExtraJobData', jobId, minLat, maxLat, minLon, maxLon],
    async () => {
      if (!dbSession) {
        throw new Error('dbSession is not defined.');
      }

      const result = await getExtraJobData(
        dbSession,
        jobId as string,
        timeZone,
        minLat,
        maxLat,
        minLon,
        maxLon
      );

      return result;
    },
    {
      enabled: !!jobId,
    }
  );
};
